const hostUrl = `@billy/${window.location.hostname}`;

const generateKey = (key) => {
  return `${ hostUrl }@${ key }`
};

export const setNewItem = (key, value) => {
  localStorage.setItem(generateKey(key), JSON.stringify(value));
};

export const getItem = (key) => {
  let item = localStorage.getItem(generateKey(key));
  return JSON.parse(item);
};

export const removeItem = (key) => {
  localStorage.removeItem(generateKey(key));
};


// WEBPACK FOOTER //
// ./src/services/localStorage.js